import ApiBaseService from "./ApiBaseService";

const getFaqs = () => {
  return ApiBaseService.get(`/faq`);
};

export { getFaqs };
